/* eslint-disable */

import React, {Component} from 'react'
import Loader from '../../loaders/loader'
import {Link} from 'react-router-dom'
import HeaderGrid from '../../Pagination/HeaderGrid'
import Sort from '../../Pagination/Sort'
import Pageing from '../../Pagination/pageing'
import http from '../../Interceptor/Interseptor'
import PAYMENT from '../../BaseComponent/PAYMENT'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import USER_MANAGE from '../../BaseComponent/USERMANAGE'

class MasterTerminal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      masters: [],
      printInfo: [],
      lengthMasters: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'reportTime_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان بارگزاری',
          value: 'reportTime',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'قیمت کل',
          value: 'totalPrice',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد سطر',
          value: 'rowsCount',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'تاریخ فایل',
          value: ' fileTimeFrom',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'نام ترمینال',
          value: 'typeAccountName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام کاربر',
          value: 'operatorName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بررسی تراکنش ها',
          value: 'operatorName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'جزییات',
          value: 'operatorName',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  componentDidMount() {
    this.getmaster()
  }

  getmaster = () => {
    this.setState({
      loading: true
    })

    let data = {
      pageSize: this.state.pageSize,
      pageNumber: this.state.pageNumber,
      sortBy: this.state.sortBy,
      export: false
    }
    http
      .get(`${PAYMENT.TRANSACTION_MASTER_LIST_PAYMENT}`, {
        params: data
      })
      .then((respond) => {
        if (respond.data.error === null) {
          $('.showBaseTable').fadeIn()
          this.setState({
            masters: respond.data.object.result,
            lengthMasters: respond.data.object.countAll,
            loading: false
          })
          console.log(this.state.masters)
        } else {
          $('.showBaseTable').fadeOut()
          this.setState({
            loading: false
          })
          alert(6854)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getmaster()
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getmaster()
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getmaster()
    }
  }

  playClick = (id) => {
    let masterId = id
    let data = {
      masterId
    }
    http
      .get(`${USER_MANAGE.USER_MANAGE_PAYMENT_TRANSACTION_REPORT_CHECK}`, {
        params: data
      })
      .then((respond) => {
        if (respond.data.error === null) {
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    return (
      <div className="rtl">
        <Loader show={loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>اصلی</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                {this.state.masters.map((item, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td>{jMoment(item.reportTime).format('jYYYY/jMM/jDD ')}</td>
                    <td>{item.totalPrice}</td>
                    <td>{item.rowsCount}</td>
                    <td>{jMoment(item.fileTimeFrom).format('jYYYY/jMM/jDD ')}</td>

                    <td>{item.typeAccountName}</td>
                    <td>{item.operatorName}</td>
                    <td>
                      <button onClick={() => this.playClick(item.id)}>
                        <img src={require('../../../image/play.svg')} alt="" />
                      </button>
                    </td>
                    <td>
                      <Link to={`/masterDetail/${item.id}`}>
                        <img src={require('../../../image/details.svg')} alt="" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthMasters}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MasterTerminal
